import { 
    IonCol,
    IonSelect,
    IonSelectOption,
    IonButton, IonCardContent, IonInput, useIonAlert, IonText
  } from '@ionic/react'
  import { useHistory } from "react-router-dom";
import {useState,  useEffect } from "react";
import {handleUpdateUserDetails,handleSignUp } from "../services/handlers"

import "../styles/SignUpContent.css";
import { GlobalStore } from "../../../store/GlobalStore";
import { setCookie } from "../../../utils/cookie"

import { handleRequestOtp } from "../services/handlers"

function SingUpContent () {
    const { getUserLoginDetails } = GlobalStore()
    const userLoginData = getUserLoginDetails()

    const [userDetails, setUserDetails] = useState({
        gender: 0,
        mobileOtp: "",
        mobileNumber: "",
        email: "",
        firstName: ""
    })

    let history = useHistory();

    const [present] = useIonAlert()

    const [showMobileVerification, setShowMobileVerification] = useState(true)

    useEffect(()=>{
        if (userLoginData.selectedInput === "mobile" && userLoginData.newUser) {
            setUserDetails({...userDetails, mobileNumber:userLoginData.mobileNumber, mobileOtp:userLoginData.otp})
            setShowMobileVerification(false)
        }
        if (userLoginData.selectedInput === "email" && userLoginData.newUser) {
            setUserDetails({...userDetails, email:userLoginData.email})
        }
    },[])
    return (
        <>
            <IonCardContent>
                        <div className='custom-label'>
                            <IonCol>
                                    <ion-label>Full Name</ion-label>
                                    <input type="text" className='custom-input' placeholder="" onChange={(e)=> handleUpdateUserDetails("firstName", e.target.value, userDetails, setUserDetails)} />
                            </IonCol>
                            <IonCol>
                                    <ion-label>Email</ion-label>
                                    <input type="text" className='custom-input' placeholder="" value={userDetails.email} onChange={(e)=> handleUpdateUserDetails("email", e.target.value, userDetails, setUserDetails)} />
                            </IonCol>
                            <IonCol className='contact'>
                                    <ion-label>Gender</ion-label>
                                    <IonSelect placeholder="Select"  onChange={(e)=> handleUpdateUserDetails("gender", e.target.value, userDetails, setUserDetails)}>
                                    <IonSelectOption value="0">Male</IonSelectOption>
                                    <IonSelectOption value="1">Female</IonSelectOption>
                                    <IonSelectOption value="2">Prefer not to specify</IonSelectOption>
                                    </IonSelect>
                            </IonCol>
                            
                            <div className="contact">
                            <IonCol className='contact'>
                                <ion-label>Contact Number</ion-label>
                                <input type="text" className='custom-input' 
                                    style={{textAlign: 'left'}}
                                    value={userDetails.mobileNumber}
                                    onChange={(e)=> {
                                        handleUpdateUserDetails("mobileNumber", e.target.value, userDetails, setUserDetails) ; 
                                        }}
                                />
                                <div >
                                    <button className='floating-end-slot' onClick={async()=>{
                                        if (userDetails.mobileNumber === "" || userDetails.mobileNumber.length !== 8) {
                                            present({
                                                message: "Invalid Mobile Number",
                                                buttons: [
                                                        'Ok'
                                                ],
                                            })
                                            return
                                        }
                            
                                        let response = await handleRequestOtp(userDetails, setUserDetails)
                                        if (!response.status) {
                                            present({
                                                message: response.message,
                                                buttons: [
                                                        'Ok'
                                                ],
                                            })
                                            return 
                                        } else {
                                            present({
                                                message: `OTP Sent to mobile number ${userDetails.mobileNumber}`,
                                                buttons: [
                                                        'Ok'
                                                ],
                                            })
                                            return
                                         }
                                    }}>Request OTP</button>
                                </div>


                            </IonCol>
                            </div>
                

                        { showMobileVerification && 
                            <IonCol>
                                    <ion-label>OTP</ion-label>
                                    <input type="text" className='custom-input' placeholder="" onChange={(e)=> handleUpdateUserDetails("mobileOtp", e.target.value, userDetails, setUserDetails)}/>
                            </IonCol>
                           
                            }
                                    
                            <p>By signing up you agree to RYDE Technologies <a className='sub-link'>Terms </a>and <a className='sub-link'>Privacy Policy.</a></p>
      
                            <IonButton color="primary" size="large" expand='block' mode='ios' onClick={async ()=>{
                                try {
                                    let response = await handleSignUp(userDetails)
                                    if(response.status) {
                                        setCookie("RydeSendToken", response.data.rydeSendToken)
                                         history.push('/booking')
                                    } else {
                                        present({
                                            message: response.message,
                                            buttons: [
                                                    'Ok'
                                            ],
                                        })
                                    }
                                    
                                } catch (err) {
                                    present({
                                        message: err.message,
                                        buttons: [
                                                'Ok'
                                        ],
                                    })
                                }
                            } }>Sign up</IonButton>
                            <a href='/login' className='link-btn'>Login</a>
                            </div>
                    </IonCardContent>
        </>
    )
}

export default SingUpContent;